import map from 'lodash/map';
import React, { Fragment } from 'react';

import { ChevronRightIcon, FolderIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';


const InfoPanelItemPath = ({ pathAsFolderData, onFolderNavigate })=>
  <div className="item-path">
    <span className="asset-category-title" style={{float:'none', marginRight:'3px'}}><FolderIcon /></span> 
    { map(pathAsFolderData, ({ name, id }, i)=>
      <Fragment key={i}>
        { i > 0 && <ChevronRightIcon /> }
        <span className="path-fragment" onClick={()=> { onFolderNavigate(id); }}>
          {name}
        </span>
      </Fragment>
    )}
  </div>;

export default InfoPanelItemPath;